/* OREN — Welle 5: Loyalty + Trust + Ask Johann logic */
(function(){

  const K = {
    purchases: 'oren_purchases',
    patinaId:  'oren_patina_id',
    lastVisit: 'oren_last_visit',
    tier:      'oren_tier',
    patinaLog: 'oren_patina_log',
    coachHistory: 'oren_coach_history',
    closedReturning: 'oren_closed_returning'
  };

  function getJSON(key, fallback){
    try{ const v = localStorage.getItem(key); return v ? JSON.parse(v) : fallback; }
    catch(e){ return fallback; }
  }
  function setJSON(key, val){
    try{ localStorage.setItem(key, JSON.stringify(val)); }catch(e){}
  }

  function getPatinaId(){ return localStorage.getItem(K.patinaId); }
  function assignPatinaId(){
    let id = getPatinaId();
    if(id) return id;
    const t = Date.now();
    const seq = 7 + (t % 9993);
    id = String(seq).padStart(4, '0');
    localStorage.setItem(K.patinaId, id);
    return id;
  }

  function renderPatinaIdBadge(){
    const id = getPatinaId();
    if(!id) return;
    const footerBottom = document.querySelector('.footer > div:last-child');
    if(!footerBottom) return;
    if(footerBottom.querySelector('.patina-id-badge')) return;
    const badge = document.createElement('span');
    badge.className = 'patina-id-badge';
    badge.innerHTML = 'Patina <span class="num">' + id + '</span>';
    footerBottom.appendChild(badge);
    requestAnimationFrame(function(){ badge.classList.add('visible'); });
  }

  function recordPurchaseIfOnOrderPage(){
    if(!document.body.classList.contains('template-customers-order') &&
       !document.body.classList.contains('template-customers')) return;
    const titleEl = document.querySelector('h1');
    if(!titleEl) return;
    const sessionKey = 'oren_order_session_' + (location.pathname || '');
    if(sessionStorage.getItem(sessionKey)) return;
    sessionStorage.setItem(sessionKey, '1');

    const items = document.querySelectorAll('section [style*="font-weight:500"][style*="color:var(--navy)"]');
    const purchases = getJSON(K.purchases, []);
    const today = new Date().toISOString().split('T')[0];
    items.forEach(function(item){
      const title = item.textContent.trim();
      if(title && title.length < 80 && !purchases.some(function(p){return p.fragment === title && p.date === today;})){
        purchases.push({ fragment: title, date: today });
      }
    });
    setJSON(K.purchases, purchases);

    if(purchases.length > 0 && !getPatinaId()){ assignPatinaId(); }
    updateTier();
  }

  function getTier(){
    const purchases = getJSON(K.purchases, []);
    if(purchases.length >= 5) return { name: 'Cellar', desc: 'Early-access to every delivery, 72h before public. Private notes from the studio.' };
    if(purchases.length >= 2) return { name: 'Cabinet', desc: 'Early-access to every delivery, 24h before public.' };
    if(purchases.length >= 1) return { name: 'Drawer', desc: 'One Fragment in the rotation. Welcome.' };
    return null;
  }
  function updateTier(){
    const tier = getTier();
    if(tier) localStorage.setItem(K.tier, tier.name);
  }

  function renderTierBadge(){
    const tier = getTier();
    if(!tier) return;
    const footerBrand = document.querySelector('.footer-brand');
    if(!footerBrand) return;
    if(footerBrand.querySelector('.tier-card')) return;
    const card = document.createElement('div');
    card.className = 'tier-card';
    card.innerHTML = '<div class="tier-label">Your tier</div><div class="tier-name">' + tier.name + '</div><div class="tier-desc">' + tier.desc + '</div>';
    footerBrand.appendChild(card);
  }

  function renderReturningWelcome(){
    if(!document.body.classList.contains('template-index')) return;
    if(localStorage.getItem(K.closedReturning) === '1') return;
    const purchases = getJSON(K.purchases, []);
    if(purchases.length === 0) return;
    const last = purchases[purchases.length - 1];
    const lastDate = new Date(last.date);
    const daysSince = Math.floor((Date.now() - lastDate.getTime()) / (1000*60*60*24));
    const tier = getTier();

    const block = document.createElement('div');
    block.className = 'returning-customer';
    block.innerHTML = ''+
      '<button class="returning-customer-close" aria-label="Hide" data-cursor="Hide">✕</button>'+
      '<div class="returning-customer-label">Welcome back</div>'+
      '<div class="returning-customer-body">'+
        'Your last Fragment was <strong>' + last.fragment + '</strong>. '+
        '<em>' + (daysSince === 0 ? 'Today.' : daysSince === 1 ? 'Yesterday.' : daysSince + ' days ago.') + '</em>'+
        (tier && tier.name !== 'Drawer' ? ' You\u2019re in <strong>' + tier.name + '</strong>. Next delivery lands in your inbox first.' : '')+
      '</div>';
    block.querySelector('.returning-customer-close').addEventListener('click', function(){
      localStorage.setItem(K.closedReturning, '1');
      block.classList.remove('visible');
    });
    const main = document.getElementById('MainContent');
    if(main && main.firstChild){
      main.insertBefore(block, main.firstChild);
      requestAnimationFrame(function(){ block.classList.add('visible'); });
    }
  }

  function checkAnniversary(){
    const purchases = getJSON(K.purchases, []);
    if(purchases.length === 0) return;
    const today = new Date();
    const todayKey = today.toISOString().split('T')[0];
    const annivShownKey = 'oren_anniv_shown_' + todayKey;
    if(sessionStorage.getItem(annivShownKey)) return;

    const matches = purchases.filter(function(p){
      const d = new Date(p.date);
      const yearAgo = new Date(today);
      yearAgo.setFullYear(today.getFullYear() - 1);
      const diff = Math.abs(d.getTime() - yearAgo.getTime());
      return diff < (1000 * 60 * 60 * 24 * 3);
    });
    if(matches.length === 0) return;
    sessionStorage.setItem(annivShownKey, '1');
    const m = matches[0];
    const block = document.createElement('div');
    block.className = 'returning-customer';
    block.style.borderLeftColor = '#e8f53d';
    block.innerHTML = ''+
      '<button class="returning-customer-close" aria-label="Hide">✕</button>'+
      '<div class="returning-customer-label">One year today</div>'+
      '<div class="returning-customer-body">'+
        'Your <strong>' + m.fragment + '</strong> is one year old. '+
        '<em>If it\u2019s still in the rotation, send us a photo — we\u2019d like to see the patina.</em> '+
        '<a href="mailto:johannhubert@orenfragments.com?subject=Patina photo — ' + encodeURIComponent(m.fragment) + '" style="color:var(--navy);text-decoration:underline;text-underline-offset:3px;">Write us</a>'+
      '</div>';
    block.querySelector('.returning-customer-close').addEventListener('click', function(){
      block.classList.remove('visible');
    });
    const main = document.getElementById('MainContent');
    if(main && main.firstChild){
      main.insertBefore(block, main.firstChild);
      requestAnimationFrame(function(){ block.classList.add('visible'); });
    }
  }

  window.OREN_addPatinaLog = function(fragment, text){
    const log = getJSON(K.patinaLog, []);
    log.unshift({
      fragment: fragment || 'My Fragment',
      text: text,
      date: new Date().toISOString().split('T')[0]
    });
    setJSON(K.patinaLog, log);
    return log;
  };

  function renderPatinaLog(){
    const container = document.querySelector('[data-patina-log]');
    if(!container) return;
    const log = getJSON(K.patinaLog, []);
    const entriesEl = container.querySelector('.patina-log-entries');
    if(!entriesEl) return;
    if(log.length === 0){
      entriesEl.innerHTML = '<div style="font-family:\'IBM Plex Mono\',monospace;font-size:12px;color:var(--dim);font-style:italic;">No entries yet. Add the first one below.</div>';
    }else{
      entriesEl.innerHTML = log.map(function(e){
        return '<div class="patina-log-entry"><div class="date">' + e.date + '</div><div class="text">' + escapeHTML(e.text) + '</div></div>';
      }).join('');
    }
  }
  function escapeHTML(s){
    return String(s).replace(/[&<>"\']/g, function(c){
      return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;','\'':'&#39;' }[c];
    });
  }

  function wirePatinaLogForm(){
    const form = document.querySelector('[data-patina-log-form]');
    if(!form) return;
    const ta = form.querySelector('textarea');
    const btn = form.querySelector('button');
    btn.addEventListener('click', function(){
      const text = (ta.value || '').trim();
      if(!text) return;
      window.OREN_addPatinaLog(null, text);
      ta.value = '';
      renderPatinaLog();
    });
  }

  /* ============================================
     ASK JOHANN (formerly Patina Coach) — letter-style advice
     ============================================ */
  function setupAskJohann(){
    const root = document.querySelector('[data-patina-coach]');
    if(!root) return;

    const select = root.querySelector('[data-pc-select]');
    const textarea = root.querySelector('[data-pc-textarea]');
    const submit = root.querySelector('[data-pc-submit]');
    const reply = root.querySelector('[data-pc-reply]');
    const replyText = root.querySelector('[data-pc-reply-text]');
    const replyTime = root.querySelector('[data-pc-reply-time]');
    const loading = root.querySelector('[data-pc-loading]');
    const errorEl = root.querySelector('[data-pc-error]');
    const historyEl = root.querySelector('[data-pc-history]');
    const pills = root.querySelectorAll('[data-pc-pill]');

    function renderHistory(){
      if(!historyEl) return;
      const list = getJSON(K.coachHistory, []);
      if(list.length === 0){ historyEl.classList.remove('visible'); return; }
      historyEl.classList.add('visible');
      const inner = historyEl.querySelector('[data-pc-history-list]');
      if(!inner) return;
      inner.innerHTML = list.slice(0, 5).map(function(item, i){
        return '<div class="aj-history-entry" data-load-index="' + i + '" data-cursor="Open"><div class="q">“' + escapeHTML(item.q.slice(0, 100)) + (item.q.length > 100 ? '…' : '') + '”</div><div class="d">' + escapeHTML(item.fragment || 'General') + ' · ' + item.date + '</div></div>';
      }).join('');
      inner.querySelectorAll('[data-load-index]').forEach(function(el){
        el.addEventListener('click', function(){
          const idx = parseInt(el.dataset.loadIndex);
          const item = list[idx];
          if(!item) return;
          textarea.value = item.q;
          if(select) select.value = item.fragmentValue || select.value;
          showReply(item.a, item.date);
          // smooth scroll to reply
          setTimeout(function(){
            reply.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }, 100);
        });
      });
    }
    renderHistory();

    pills.forEach(function(pill){
      pill.addEventListener('click', function(){
        textarea.value = pill.dataset.pcPill;
        textarea.focus();
        pills.forEach(function(p){ p.classList.remove('active'); });
        pill.classList.add('active');
      });
    });

    function showLoading(on){
      if(loading) loading.classList.toggle('visible', !!on);
      if(submit) submit.disabled = !!on;
    }
    function showError(msg){
      if(!errorEl) return;
      errorEl.textContent = msg;
      errorEl.classList.add('visible');
      setTimeout(function(){ errorEl.classList.remove('visible'); }, 6000);
    }
    function showReply(text, when){
      reply.classList.add('visible');
      replyText.innerHTML = '';
      if(replyTime) replyTime.textContent = when || 'now';
      const paragraphs = text.split(/\n\n+/);
      let pi = 0;
      function nextPara(){
        if(pi >= paragraphs.length) return;
        const p = document.createElement('p');
        replyText.appendChild(p);
        const full = paragraphs[pi];
        let i = 0;
        function step(){
          if(i >= full.length){ pi++; nextPara(); return; }
          p.innerHTML += escapeHTML(full[i]);
          i++;
          setTimeout(step, 14 + Math.random() * 18);
        }
        step();
      }
      nextPara();
    }

    submit.addEventListener('click', function(e){
      e.preventDefault();
      const question = (textarea.value || '').trim();
      if(!question){ textarea.focus(); return; }
      const fragmentValue = select ? select.value : '';
      const fragmentLabel = select ? select.options[select.selectedIndex].text : 'My Fragment';
      submitQuestion(question, fragmentValue, fragmentLabel);
    });

    function submitQuestion(question, fragmentValue, fragmentLabel){
      showLoading(true);
      if(errorEl) errorEl.classList.remove('visible');
      reply.classList.remove('visible');

      const endpoint = window.OREN_COACH_API;
      const payload = {
        question: question,
        fragment: fragmentLabel,
        fragmentCode: fragmentValue
      };

      const handleResponse = function(answer){
        const date = new Date().toISOString().split('T')[0];
        showLoading(false);
        showReply(answer, 'just now');
        const list = getJSON(K.coachHistory, []);
        list.unshift({ q: question, a: answer, fragment: fragmentLabel, fragmentValue: fragmentValue, date: date });
        setJSON(K.coachHistory, list.slice(0, 20));
        renderHistory();
        setTimeout(function(){
          reply.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 200);
      };

      if(!endpoint){
        const answer = localResponse(question, fragmentValue);
        setTimeout(function(){ handleResponse(answer); }, 800);
        return;
      }

      fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      }).then(function(r){
        if(!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      }).then(function(data){
        if(!data || !data.answer) throw new Error('No answer in response');
        handleResponse(data.answer);
      }).catch(function(err){
        showLoading(false);
        const answer = localResponse(question, fragmentValue);
        handleResponse(answer);
        console.warn('Ask Johann API failed, using local fallback:', err);
      });
    }

    function localResponse(q, fragmentCode){
      const text = q.toLowerCase();
      for(const entry of COACH_LIBRARY){
        if(entry.match.some(function(m){ return text.indexOf(m) !== -1; })){
          return entry.answer(fragmentCode);
        }
      }
      return 'Honest answer: it depends on the fabric and what kind of patina you\u2019re after. Tell me a little more — what does it look like, what does it feel like, what do you want it to do?\n\nIf it\u2019s an emergency (real stain, real tear), write to johannhubert@orenfragments.com and we\u2019ll talk through it. The same hands that made it answer the mail.';
    }
  }

  const COACH_LIBRARY = [
    {
      match: ['hole', 'tear', 'rip', 'loch'],
      answer: function(){ return 'Leave it. Patches look intentional only when they\u2019re not. Six months from now the hole will have a shape — a circle, an oval — and that\u2019s the piece.\n\nIf it gets bigger fast (more than a coin), darn it from the inside with a thread one shade darker than the fabric. Don\u2019t hide the stitch. *Let it show.*'; }
    },
    {
      match: ['fade', 'faded', 'verblass'],
      answer: function(){ return 'Indigo and natural dye fade with light and salt. To speed it up: sea water, full sun, one afternoon. Lay flat, turn once. For cotton in general, hot wash with a tablespoon of salt accelerates the wash-down by months.\n\n*Most people want this. A few try to stop it. Both are fine.*'; }
    },
    {
      match: ['stain', 'fleck'],
      answer: function(){ return 'Cold water first, immediately. Blot, don\u2019t rub. If oil: cornstarch or talc for 30 minutes, then brush off, then wash.\n\nIf it doesn\u2019t come out, *consider keeping it*. A coffee mark from a Tuesday morning is more honest than a perfect garment. The piece is becoming yours.'; }
    },
    {
      match: ['stiff', 'starchy', 'crisp'],
      answer: function(){ return 'New cotton and linen are stiff on purpose — it\u2019s the sizing from the mill. First wash, no detergent, cold. Second wash, half a capful, cold. By the third, the fabric is yours.\n\nIf you want it faster: tumble dry once on low for ten minutes only, then air. *Heat opens the fibres.*'; }
    },
    {
      match: ['soft', 'softer', 'weich'],
      answer: function(){ return 'Time, mostly. Heavyweight cotton (280gsm and up) takes ten to twenty wears to fully drop. Things that help: cold washes, no fabric softener (it coats the fibres), air dry, light tumble. *Wear it more than you wash it.*\n\nFor a shortcut: soak twenty minutes in cold water with a quarter cup of distilled vinegar. Rinse well. The vinegar opens the weave.'; }
    },
    {
      match: ['wash', 'first wash', 'erste w'],
      answer: function(){ return 'First wash matters. Inside out, cold, on its own or with similar colours. No detergent on the first one — just water. Or a quarter dose if it needs it.\n\nLay flat to dry the first three times. After that, line dry or low tumble. *Heat is the enemy of structure, not of softness.*'; }
    },
    {
      match: ['wrinkle', 'crinkle', 'crease', 'falten'],
      answer: function(){ return 'On linen and washed cotton: leave them. The wrinkle is the point. Iron only if a specific occasion asks for it, and even then — medium heat, steam, do the back only.\n\nIf you really want to flatten: hang the piece in the bathroom while you shower. Steam from below does what an iron does without flattening the texture.'; }
    },
    {
      match: ['silver', 'jewelry', 'jewellery', 'ring', 'chain', 'tarnish'],
      answer: function(){ return 'Silver wants to turn. *Let it.* The dark in the recesses is what gives the piece its shape — it makes the form readable.\n\nIf you ever want to polish back to bright: a soft cloth with a tiny amount of toothpaste (not gel). Rub gently, rinse, dry. Avoid silver dip — it strips too much, the piece goes back to looking new and that\u2019s the wrong direction.'; }
    },
    {
      match: ['shrink', 'shrunk', 'eingelaufen'],
      answer: function(){ return 'Most OREN apparel is pre-washed at the mill, so unwanted shrinkage is small — about 2 to 4 percent on a hot wash. If you\u2019ve already shrunk it: lay it flat damp, stretch gently in the dimension you need, let it dry pinned. *Will come back most of the way.*\n\nFor preventing: cold wash, hang dry. Heat is what shrinks fabric, not water.'; }
    },
    {
      match: ['smell', 'odor', 'odour', 'sweat'],
      answer: function(){ return 'Cold wash with a half cup of white vinegar in the rinse. Air dry in the sun for an afternoon. Sun does what no detergent can.\n\nWool: don\u2019t wash unless really needed. Air it on a hanger for a day or two between wears. *Most wool problems are solved by waiting.*'; }
    },
    {
      match: ['pill', 'pilling', 'fuzz'],
      answer: function(){ return 'Pilling is friction — backpack straps, seat belts, sleeves against jackets. The piece is finding its shape.\n\nGet a pumice stone or a sweater comb. Pull gently in one direction. Don\u2019t shave, don\u2019t cut. The fabric underneath is fine. After a few clearings, the surface stabilises and the pilling slows.'; }
    },
    {
      match: ['too small', 'too big', 'fit'],
      answer: function(){ return 'Cotton you can stretch back damp — lay flat, pin, dry. Linen the same.\n\nIf it\u2019s a size problem from the start: write me at johannhubert@orenfragments.com. I exchange for two weeks, no questions. *Better to send back than to live in the wrong size.*'; }
    },
    {
      match: ['care', 'instruction'],
      answer: function(){ return 'Short version, true for almost everything: cold wash, inside out, no fabric softener, no high heat. Air dry when you can, low tumble when you can\u2019t.\n\nLonger version: *wash less than you think you need to.* Air a piece between wears. Most fabrics get better with time, not with detergent.'; }
    },
    {
      match: ['indigo', 'bleach'],
      answer: function(){ return 'For indigo to fade fast: sea water + sun. Or warm wash with a teaspoon of regular salt and a quick run.\n\nDon\u2019t use chlorine bleach — it strips unevenly, leaves the fabric weak. *If you want the wash-down, do it slowly, over months, with the body and the sun.*'; }
    }
  ];

  function init(){
    recordPurchaseIfOnOrderPage();
    renderPatinaIdBadge();
    renderTierBadge();
    renderReturningWelcome();
    checkAnniversary();
    renderPatinaLog();
    wirePatinaLogForm();
    setupAskJohann();
  }
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  }else{
    init();
  }
})();
